import { render, staticRenderFns } from "./DetailsGrid.vue?vue&type=template&id=ad15bb00&"
import script from "./DetailsGrid.vue?vue&type=script&setup=true&lang=js&"
export * from "./DetailsGrid.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./DetailsGrid.vue?vue&type=style&index=0&id=ad15bb00&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports